import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/stores/use-auth-store.ts";
import { useMutation } from "@tanstack/react-query";
import { authApi } from "@/services/auth-api.ts";
import { toast } from "sonner";

// 로그인
export function useLogin() {
  const navigate = useNavigate();
  const { setTokens, setUserId, deviceId, initializeDeviceId } = useAuthStore();

  return useMutation({
    mutationFn: async ({
      loginId,
      password
    }: {
      loginId: string;
      password: string;
    }) => {
      // Device ID 확인/생성
      let currentDeviceId = deviceId;
      if (!currentDeviceId) {
        initializeDeviceId();
        currentDeviceId = useAuthStore.getState().deviceId!;
      }

      return await authApi.login(
        {loginId, password},
        currentDeviceId
      );
    },
    onSuccess: (data, variables) => {
      const { accessToken, refreshToken } = data;
      setTokens(accessToken, refreshToken);

      setUserId(variables.loginId);

      toast.success("로그인 되었습니다.")
      navigate("/");
    },
    onError: (error: any) => {
      const errorMessage = error.response?.data?.message || '로그인에 실패했습니다.';
      toast.error(errorMessage);
    },
  })
}

// 로그아웃
export function useLogout() {
  const navigate = useNavigate();
  const { clearTokens } = useAuthStore();

  return useMutation({
    mutationFn: authApi.logout,
    onSuccess: (data) => {
      clearTokens();
      toast.success(data.message || "로그아웃 되었습니다.")
      navigate("/login");
    },
    onError: (error: any) => {
      clearTokens();
      const errorMessage = error.response?.data?.message || '로그아웃 중 오류가 발생했습니다.';
      toast.error(errorMessage);
      navigate('/login')
    }
  })
}